// extracted by mini-css-extract-plugin
module.exports = {"topicList":"TopicList_topicList__w7tlk","topicCard":"TopicList_topicCard__ivI_9","selectedTopicCard":"TopicList_selectedTopicCard__OppKZ"};